export default {
  async bind(el, binding) {
    let url = `/img/${binding.value}.png`

    const isSupportWebp = () => {
      const canvas = document.createElement('canvas')

      return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0
    }

    const isFirefox = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./)
    // eslint-disable-next-line radix
    const firefoxVer = isFirefox ? parseInt(isFirefox[1]) : 0

    if (isSupportWebp() || firefoxVer >= 65) {
      url = url.replace('.png', '.webp')
    }

    el.style.backgroundImage = `url(${url})`
  }
}
